import { CustomerCalculatedSubscriptionStateEnum } from '@src/graphql/generated';

export const MIN_SLOTS_COUNT = 1;
export const MAX_SLOTS_COUNT = 99;

export const INACTIVE_SUBSCRIPTION_STATES = [
  CustomerCalculatedSubscriptionStateEnum.TRIAL_ENDED,
  CustomerCalculatedSubscriptionStateEnum.SUBSCRIPTION_INACTIVE,
];

export const LOCKED_STATES = [
  CustomerCalculatedSubscriptionStateEnum.TRIAL_ACTIVE,
  CustomerCalculatedSubscriptionStateEnum.TRIAL_ENDED,
  CustomerCalculatedSubscriptionStateEnum.SUBSCRIPTION_INACTIVE,
];

export const SUBSCRIBE_ERROR_MESSAGES = {
  ALREADY_CANCELLED: 'Your Subscription is already cancelled',
  // We shouldn't show this kind of message, it will make user more confused. show default error message instead
  ALREADY_SUBSCRIBED: 'You already have an active subscription',
  INVALID_PLANTYPE: null,
  NOT_ENOUGH_SLOTS: 'Published openings limit is reached',
  PAYMENT_METHOD_MISSING: 'Payment method is missing',
};

export const CYCLES = {
  HALF_YEARLY: 'HALF_YEARLY',
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
};

export const SUBSCRIPTION_PLANS = {
  BASIC: 'SUBSCRIPTION_BASIC',
  FREEMIUM: 'FREEMIUM',
  STARTER: 'SUBSCRIPTION_STARTER',
  SUBSCRIPTION_HIGH_BASE: 'SUBSCRIPTION_HIGH_BASE',
  SUBSCRIPTION_LIMITED_HIGH_BASE: 'SUBSCRIPTION_LIMITED_HIGH_BASE',
  SUBSCRIPTION_LIMITED_LOW_BASE: 'SUBSCRIPTION_LIMITED_LOW_BASE',
  SUBSCRIPTION_LOW_BASE: 'SUBSCRIPTION_LOW_BASE',
  UNLIMITED: 'SUBSCRIPTION_UNLIMITED',
};

export const CYCLE_LABELS = {
  [CYCLES.MONTHLY]: '/mo',
  [CYCLES.HALF_YEARLY]: '/6mo',
  [CYCLES.YEARLY]: '/yr',
};

export const SUBSCRIPTION_STARTER_BENEFITS = ['Access to people', 'See chat history'];

export const SUBSCRIPTION_BASIC_BENEFITS = [
  'Dedicated account manager',
  'Featuring blog posts',
  'Personal On-boarding',
];

export const SUBSCRIPTION_UNLIMITED_BENEFITS = ['Unlimited active job offers', 'Unlimited applicants'];
